export enum Sort {
  Desc = "DESC",
  Asc = "ASC"
}
